<template>
  <el-card id="UserRecipeTab">
    <template #header>
      <h4>{{ $t('我的菜谱') }}</h4>
    </template>

    <el-tabs v-model="activeName">
      <template v-for="item in comp">
        <el-tab-pane :key="item.name" :label="`${$t(item.label)}（${item.count}）`" :name="item.name">
          <user-recipe-list :current="activeName" :tab-current="item.name" :status="item.name" />
        </el-tab-pane>
      </template>
    </el-tabs>
  </el-card>
</template>

<script>
import UserRecipeList from "@/components/user/UserRecipeList";
import {request} from "@/config/request";
export default {
  name: "UserRecipeTab",
  components: {UserRecipeList},
  data() {
    return {
      activeName: null,
      comp: [
        {name: "audit", label: "审核中", count: 0},
        {name: "up", label: "上架中", count: 0},
        {name: "draft", label: "仓库中", count: 0},
      ]
    }
  },
  methods: {
    // 加载食谱统计数量
    async loadRecipeCount() {
      try {
        const params = {
          userNum: this.$route.query.num,
        }
        let res = await request(this.$api.cookbook.listMy, params);
        const countMap = res.countMap;
        this.comp.forEach(item => {
          item.count = countMap[item.name + "Count"] || 0;
        })
      } catch (e) {
        console.error("食谱统计数量", e);
      }
    }
  },
  mounted() {
    // 监听组件是否出现在视口
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        console.log('组件出现在视口 UserRecipeTab');
        this.activeName = "audit";
        this.loadRecipeCount();
        this.observer.unobserve(document.getElementById("UserRecipeTab"));
      }
    })

    this.observer.observe(document.getElementById("UserRecipeTab"));
    this.$once('hook:beforeDestroy', () => {
      this.observer.disconnect();
    })
  },
}
</script>

<style scoped>

</style>
